import { render, staticRenderFns } from "./BorderBox7.vue?vue&type=template&id=0f7fe13f"
import script from "./BorderBox7.vue?vue&type=script&lang=js"
export * from "./BorderBox7.vue?vue&type=script&lang=js"
import style0 from "./BorderBox7.vue?vue&type=style&index=0&id=0f7fe13f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports